import React from 'react';
import { LFC } from '../../Legacy';
import { NotFoundCrash } from '../Crash';
import { ManageApprovalsView } from './ManageApprovalsView';
import { ManageBillingView } from './ManageBillingView';
import { ManageDangerZoneView } from './ManageDangerZoneView';
import { ManageSecurityView } from './ManageSecurityView';
import { ManageUsersView } from './ManageUsersView';
import { ManageWorkspacesView } from './ManageWorkspacesView';
import { ManagementRootView } from './ManagementRootView';
import { ManageIntegrationsView } from './integrations/ManageIntegrationsView';

export type ManagementSwitchProps = { section: string, param: string };
export const ManagementSwitch: LFC<ManagementSwitchProps> = ({ section, param }) => {
    if (!section) return <ManagementRootView />;
    if (section === 'approvals') return <ManageApprovalsView param={param} />;
    if (section === 'billing') return <ManageBillingView param={param} />;
    if (section === 'danger') return <ManageDangerZoneView param={param} />;
    if (section === 'integrations') return <ManageIntegrationsView param={param} />;
    if (section === 'people') return <ManageUsersView param={param} />;
    if (section === 'security') return <ManageSecurityView param={param} />;
    if (section === 'workspaces') return <ManageWorkspacesView param={param} />;
    return <NotFoundCrash />;
};
